var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMedicalRecord(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 28,
    height: 28,
    xmlSpace: "preserve",
    id: "medicalRecord",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "medicalRecord-bezier",
    stroke: "none",
    fill: "rgb(245, 74, 120)",
    d: "M 24.26,8.35 L 24.26,8.35 16.26,0.24 16.26,0.24 16.26,0.24 C 16.1,0.09 15.9,0 15.68,0 L 4.71,0 4.71,-0 C 4.04,-0 3.5,0.55 3.5,1.23 L 3.5,26.77 3.5,26.77 C 3.5,27.45 4.04,28 4.71,28 L 23.29,28 23.29,28 C 23.96,28 24.5,27.45 24.5,26.77 L 24.5,8.94 24.5,8.94 C 24.5,8.72 24.41,8.51 24.26,8.35 L 24.26,8.35 Z M 16.49,2.83 L 21.71,8.11 16.49,8.11 16.49,2.83 Z M 22.87,26.34 L 5.13,26.34 5.13,1.66 14.86,1.66 14.86,8.94 14.86,8.94 C 14.86,9.39 15.23,9.76 15.68,9.76 L 22.87,9.76 22.87,26.34 Z M 6.8,12.87 L 6.8,23.54 6.8,23.54 C 6.8,23.99 7.16,24.36 7.62,24.36 L 20.38,24.36 20.38,24.36 C 20.83,24.36 21.2,23.99 21.2,23.54 L 21.2,12.87 21.2,12.87 C 21.2,12.41 20.83,12.04 20.38,12.04 L 7.62,12.04 7.62,12.04 C 7.16,12.04 6.8,12.41 6.8,12.87 Z M 8.43,20.81 L 13.19,20.81 13.19,22.71 8.43,22.71 8.43,20.81 Z M 13.19,19.15 L 8.43,19.15 8.43,17.25 13.19,17.25 13.19,19.15 Z M 14.82,17.25 L 19.57,17.25 19.57,19.15 14.82,19.15 14.82,17.25 Z M 14.82,22.71 L 14.82,20.81 19.57,20.81 19.57,22.71 14.82,22.71 Z M 19.57,15.6 L 14.82,15.6 14.82,13.7 19.57,13.7 19.57,15.6 Z M 13.19,13.7 L 13.19,15.6 8.43,15.6 8.43,13.7 13.19,13.7 Z M 13.19,13.7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedicalRecord);
export default __webpack_public_path__ + "static/media/medicalRecord.c6ee23ee6180836019654b4d6188e136.svg";
export { ForwardRef as ReactComponent };